"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  StrategyChess: ['strategy-chess', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.105,23.2a1,1,0,0,0,.9.553H22A1,1,0,0,0,22.9,23.2l1-2a1,1,0,0,0,0-.894l-2.224-4.447a1.987,1.987,0,0,0-1.789-1.106H19a1,1,0,1,0,0,2h.727a.249.249,0,0,1,.224.138l1.75,3.5a.25.25,0,0,1-.224.362H2.523a.25.25,0,0,1-.213-.119.248.248,0,0,1-.011-.243l1.75-3.5a.249.249,0,0,1,.224-.138H5a1,1,0,0,0,0-2H4.118a1.988,1.988,0,0,0-1.789,1.105L.105,20.3a1,1,0,0,0,0,.894Z', 'M9.61,8.521a9.224,9.224,0,0,0-1.562,5.152.249.249,0,0,1-.178.229,1.19,1.19,0,0,0-.839.8.2.2,0,0,0-.009.03l-.377,1.888a1,1,0,0,0,.98,1.2h8.78a1,1,0,0,0,.981-1.2h0l-.394-1.947a.178.178,0,0,0-.009-.033,1.164,1.164,0,0,0-.838-.741.249.249,0,0,1-.181-.213,7.728,7.728,0,0,0-2.137-4.349.25.25,0,0,1-.021-.319L15.735,6.36a1.484,1.484,0,0,0,.286-.83l.007-.178h0c.045-1.129.092-2.3-2.289-3.486-1-.5-2.988-1.556-2.989-1.556a.5.5,0,0,0-.734.441V2.427a.25.25,0,0,1-.105.2C6.589,5,6.741,4.9,6.736,4.9a1.512,1.512,0,0,0-.7,1.554c.287,1.465,1.4,1.361,1.479,1.361H9.667a.25.25,0,0,1,.184.418A3.517,3.517,0,0,0,9.61,8.521Z', 'M18.250 18.501 A0.750 0.750 0 1 0 19.750 18.501 A0.750 0.750 0 1 0 18.250 18.501 Z']],
  StrategySplit: ['strategy-split', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24a1.25,1.25,0,0,0,1.25-1.25v-.421a10.315,10.315,0,0,1,5.714-9.254.252.252,0,0,1,.343.128l.251.606a1,1,0,0,0,.8.61,1.066,1.066,0,0,0,.126.008,1,1,0,0,0,.8-.4L23.8,10.685a1,1,0,0,0-.66-1.592L18.994,8.51a1,1,0,0,0-1.062,1.373l.225.543a.25.25,0,0,1-.123.321,12.816,12.816,0,0,0-4.341,3.389.251.251,0,0,1-.443-.16V6.212a.249.249,0,0,1,.25-.25h.807a1.042,1.042,0,0,0,.9-1.572L12.9.475a1.087,1.087,0,0,0-1.8,0L8.794,4.39a1.043,1.043,0,0,0,.9,1.572H10.5a.249.249,0,0,1,.25.25v7.764a.251.251,0,0,1-.443.16,12.816,12.816,0,0,0-4.341-3.389.25.25,0,0,1-.122-.321l.224-.543A1,1,0,0,0,5.006,8.51L.86,9.093A1,1,0,0,0,.2,10.686l2.52,3.343a1,1,0,0,0,.8.4,1.066,1.066,0,0,0,.126-.008,1,1,0,0,0,.8-.609l.251-.607a.254.254,0,0,1,.144-.138.251.251,0,0,1,.2.011,10.314,10.314,0,0,1,5.714,9.253v.421A1.25,1.25,0,0,0,12,24Z']],
  TargetCenterMonitor: ['target-center-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.72,7.032a.249.249,0,0,1,.209-.116h1.663a2.451,2.451,0,0,0,1.746-.723l2.385-2.385a.494.494,0,0,0-.349-.843H19.657a.246.246,0,0,1-.247-.247V.5a.494.494,0,0,0-.843-.35L16.182,2.53a2.456,2.456,0,0,0-.724,1.748V5.446a.247.247,0,0,1-.116.209.575.575,0,0,0-.089.069L11.3,9.676a.988.988,0,0,0,1.4,1.4L16.65,7.121A.457.457,0,0,0,16.72,7.032Z', 'M14.429,20.254h6.957a1.978,1.978,0,0,0,1.976-1.976V8.4a.988.988,0,0,0-1.976,0v7.163a.247.247,0,0,1-.247.247H2.861a.247.247,0,0,1-.247-.247V4.693a.248.248,0,0,1,.247-.247h9.551a.988.988,0,1,0,0-1.975h-9.8A1.978,1.978,0,0,0,.638,4.446V18.278a1.978,1.978,0,0,0,1.976,1.976H9.565a.247.247,0,0,1,.236.319,8.409,8.409,0,0,1-.842,1.82.248.248,0,0,1-.211.12l-1.172,0a.741.741,0,0,0,0,1.482h0l9.361-.041a.741.741,0,0,0,0-1.482h0l-1.711.008a.245.245,0,0,1-.213-.121,8.281,8.281,0,0,1-.82-1.791.248.248,0,0,1,.037-.219A.252.252,0,0,1,14.429,20.254Z', 'M11.027,8.1a.988.988,0,1,0-.779-1.816A4.447,4.447,0,1,0,16.276,11.6a.988.988,0,0,0-1.9-.542A2.47,2.47,0,1,1,11.027,8.1Z']],
  TargetCenterPhone: ['target-center-phone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.757,6.662l2.351-2.35a.488.488,0,0,0-.345-.832H18.092a.249.249,0,0,1-.25-.25V.56a.486.486,0,0,0-.831-.345l-2.35,2.35a2.416,2.416,0,0,0-.713,1.722V5.922a.25.25,0,0,1-.117.212.442.442,0,0,0-.085.066L8.877,11.068a.974.974,0,0,0,1.377,1.377l4.869-4.868a.53.53,0,0,0,.074-.1.217.217,0,0,1,.186-.105h1.653A2.418,2.418,0,0,0,18.757,6.662Z', 'M8.95,9.909a.974.974,0,0,0-.616-1.847,3.895,3.895,0,1,0,4.928,4.926.974.974,0,0,0-1.849-.614A1.948,1.948,0,1,1,8.95,9.909Z', 'M5.184,23.928h8.764a2.437,2.437,0,0,0,2.434-2.434V11.757a.974.974,0,0,0-1.948,0v6.566a.25.25,0,0,1-.25.25H4.947a.25.25,0,0,1-.25-.25V4.218a.249.249,0,0,1,.25-.25H12a.487.487,0,0,0,.487-.488V1.047A.486.486,0,0,0,12,.56H5.184A2.436,2.436,0,0,0,2.75,2.994v18.5A2.437,2.437,0,0,0,5.184,23.928Zm4.382-3.407a.974.974,0,1,1-.974.974A.975.975,0,0,1,9.566,20.521Z']],
  TargetCenter2: ['target-center-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.962,3.808A.5.5,0,0,0,22.5,3.5H19.75a.249.249,0,0,1-.25-.25V.5a.5.5,0,0,0-.853-.354L16.233,2.56A2.484,2.484,0,0,0,15.5,4.328V6.012a.25.25,0,0,1-.117.212.49.49,0,0,0-.09.069l-5,5a1,1,0,1,0,1.414,1.414l5-5a.463.463,0,0,0,.07-.09.253.253,0,0,1,.212-.117h1.683a2.483,2.483,0,0,0,1.768-.733l2.414-2.414A.5.5,0,0,0,22.962,3.808Z', 'M11,8a1,1,0,0,0,0-2,6,6,0,1,0,6,6,1,1,0,0,0-2,0,4,4,0,1,1-4-4Z', 'M21,12a1,1,0,0,0-2,0,8,8,0,1,1-8-8,1,1,0,0,0,0-2A9.991,9.991,0,0,0,3.839,18.968a.25.25,0,0,1,.011.337L1.241,22.35a1,1,0,0,0,1.519,1.3l2.662-3.105a.249.249,0,0,1,.321-.05,9.94,9.94,0,0,0,10.514,0,.25.25,0,0,1,.322.05l2.662,3.105a1,1,0,0,0,1.519-1.3l-2.609-3.045a.249.249,0,0,1,.01-.336A9.962,9.962,0,0,0,21,12Z']],
  TargetCenter1: ['target-center-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.92,20.549a.249.249,0,0,1,0,.309L.716,22.38a1,1,0,1,0,1.568,1.24l1.052-1.329a.25.25,0,0,1,.344-.046,8.964,8.964,0,0,0,10.856-.153.249.249,0,0,1,.341.03c.391.439,1.375,1.543,1.376,1.543a1.013,1.013,0,0,0,1.412.081,1,1,0,0,0,.082-1.411l-1.5-1.685a.25.25,0,0,1-.014-.314,8.956,8.956,0,0,0,.41-10.084.256.256,0,0,0-.4-.041L14.6,11.859a.242.242,0,0,0-.042.285,6.278,6.278,0,1,1-1.94-2.232.25.25,0,0,1,.032.38l-.724.724a.25.25,0,0,1-.315.031,4.69,4.69,0,0,0-3.656-.681,4.751,4.751,0,1,0,5.659,5.773,4.712,4.712,0,0,0-.12-2.671.252.252,0,0,0-.415-.087L10.961,15.5a.236.236,0,0,0-.061.1A2,2,0,1,1,9,13a2.059,2.059,0,0,1,.353.031.251.251,0,0,1,.133.423L8.6,14.34a.749.749,0,0,0,0,1.06.763.763,0,0,0,1.061,0l7.326-7.327A.251.251,0,0,1,17.164,8H20.5a.5.5,0,0,0,.339-.132l3-2.757a.5.5,0,0,0-.18-.842l-2.826-.942a.253.253,0,0,1-.158-.158L19.732.342a.5.5,0,0,0-.37-.331.506.506,0,0,0-.473.151l-2.758,3A.5.5,0,0,0,16,3.5V6.836a.255.255,0,0,1-.073.177l-.961.961a.25.25,0,0,1-.333.017A8.992,8.992,0,0,0,1.92,20.549Z']],
  TargetCorrect: ['target-correct', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,3.914V5.5a.249.249,0,0,1-.1.2,1.168,1.168,0,0,0-.107.093l-5,5a1,1,0,1,0,1.414,1.414l5-5A.938.938,0,0,0,15.8,7.1.251.251,0,0,1,16,7h1.586a1.507,1.507,0,0,0,1.06-.44l2.708-2.707A.5.5,0,0,0,21,3H18.75a.25.25,0,0,1-.25-.25V.5a.5.5,0,0,0-.854-.354L14.939,2.853A1.491,1.491,0,0,0,14.5,3.914Z', 'M10,5.5a6,6,0,0,0,0,12,1,1,0,0,0,0-2,4,4,0,0,1,0-8,1,1,0,0,0,0-2Z', 'M10,21.5a1,1,0,0,0,0-2A8,8,0,1,1,12.225,3.813a1,1,0,1,0,.554-1.921A10,10,0,1,0,10,21.5Z', 'M17.5,24A6.5,6.5,0,1,0,11,17.5,6.508,6.508,0,0,0,17.5,24Zm-3.394-6.323a.752.752,0,0,1,1.061,0l1.3,1.3a.255.255,0,0,0,.2.073.248.248,0,0,0,.182-.1L19.574,15.3a.75.75,0,0,1,1.2.9L17.868,20.08a1.5,1.5,0,0,1-1.1.6l-.109,0a1.493,1.493,0,0,1-1.056-.441l-1.5-1.5A.75.75,0,0,1,14.106,17.677Z']],
  BusinessClimbTop1: ['business-climb-top-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.689,15.982a.246.246,0,0,0-.173.115L7.874,18.7a.25.25,0,0,1-.423,0L5.6,15.764c-.778-1.214-1.608.717-5.512,6.918a.577.577,0,0,0,.489.885H22a1,1,0,0,0,.846-1.532L19.107,16.1a.248.248,0,0,0-.173-.115.254.254,0,0,0-.2.057c-1.2,1.015-1.543,1.455-2.364,1.455a1.745,1.745,0,0,1-1.239-.509h0l-.643-.64a.249.249,0,0,0-.353,0l-.643.642a1.76,1.76,0,0,1-2.367.1L9.889,16.039A.255.255,0,0,0,9.689,15.982Z', 'M14.3.433a1,1,0,0,0-1,1v8.584a.243.243,0,0,1-.039.133l-2.667,4.237a.25.25,0,0,0,.05.324l1.452,1.227a.251.251,0,0,0,.338-.014l.642-.642a1.754,1.754,0,0,1,2.475,0l.642.642a.25.25,0,0,0,.338.014l1.452-1.227a.25.25,0,0,0,.05-.324l-2.72-4.32a.082.082,0,0,1-.013-.046V7.183a.25.25,0,0,1,.25-.25h3.2a.25.25,0,0,1,.25.25v1.25a.5.5,0,0,0,.5.5h3.875a.573.573,0,0,0,.625-.5v-4a.573.573,0,0,0-.625-.5H21.75a.25.25,0,0,0-.25.25v2.25a.5.5,0,0,1-1,0v-4a.5.5,0,0,0-.5-.5H15.548a.25.25,0,0,1-.25-.25v-.25A1,1,0,0,0,14.3.433Z']],
  TargetMiss: ['target-miss', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.191.039a.5.5,0,0,0-.545.107L14.939,2.853A1.491,1.491,0,0,0,14.5,3.914V5.5a.249.249,0,0,1-.1.2,1.168,1.168,0,0,0-.107.093l-5,5a1,1,0,1,0,1.414,1.414l5-5A.938.938,0,0,0,15.8,7.1.251.251,0,0,1,16,7h1.586a1.507,1.507,0,0,0,1.06-.44l2.708-2.707A.5.5,0,0,0,21,3H18.75a.25.25,0,0,1-.25-.25V.5A.5.5,0,0,0,18.191.039Z', 'M10,5.5a6,6,0,0,0,0,12,1,1,0,0,0,0-2,4,4,0,0,1,0-8,1,1,0,0,0,0-2Z', 'M10,21.5a1,1,0,0,0,0-2A8,8,0,1,1,12.225,3.813a1,1,0,1,0,.554-1.921A10,10,0,1,0,10,21.5Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm1.237,6.677,1.414,1.415a.75.75,0,0,1-1.06,1.06l-1.414-1.414a.25.25,0,0,0-.354,0l-1.414,1.414a.75.75,0,0,1-1.06-1.06l1.414-1.415a.25.25,0,0,0,0-.353L14.849,15.91a.75.75,0,0,1,1.06-1.061l1.414,1.414a.252.252,0,0,0,.354,0l1.414-1.414a.75.75,0,1,1,1.06,1.061l-1.414,1.414A.25.25,0,0,0,18.737,17.677Z']],
  BusinessClimbTop: ['business-climb-top', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.256,2.312a.5.5,0,0,0-.391-.812H16.131a.249.249,0,0,1-.245-.2,1,1,0,0,0-1.98.2V9.928a.255.255,0,0,1-.039.134l-2.681,4.257a.252.252,0,0,0,.05.325l1.452,1.227a.251.251,0,0,0,.338-.014l.642-.642a1.752,1.752,0,0,1,2.475,0l.643.641a.248.248,0,0,0,.337.015l1.452-1.227a.252.252,0,0,0,.05-.325l-2.681-4.257a.254.254,0,0,1-.038-.134V6.75a.25.25,0,0,1,.25-.25h5.709a.5.5,0,0,0,.391-.812l-1.1-1.376a.5.5,0,0,1,0-.624Z', 'M.478,23.2a.575.575,0,0,0,.506.3h21.61a1,1,0,0,0,.847-1.532L19.7,16.029a.248.248,0,0,0-.173-.114.251.251,0,0,0-.2.057l-1.236,1.045a1.758,1.758,0,0,1-2.367-.1l-.643-.641a.25.25,0,0,0-.353,0l-.643.643a1.76,1.76,0,0,1-2.367.1l-1.236-1.045a.249.249,0,0,0-.373.057L8.374,18.785a.25.25,0,0,1-.423,0L6.006,15.7a.729.729,0,0,0-1.156,0L.5,22.614A.575.575,0,0,0,.478,23.2Z']],
  GraphStatisticsCoffee: ['graph-statistics-coffee', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.252,15.707a1,1,0,0,0,1.414,0,2.378,2.378,0,0,0,.07-3.534c-.457-.606-.457-.606-.1-.966a1,1,0,1,0-1.414-1.414,2.409,2.409,0,0,0-.085,3.585,2.2,2.2,0,0,1,.36.574s-.02.112-.248.341A1,1,0,0,0,18.252,15.707Z', 'M13.5,17.548v2.976C13.5,22.571,15.174,24,17.571,24a3.944,3.944,0,0,0,3.342-1.444.251.251,0,0,1,.185-.1A2.8,2.8,0,0,0,24,19.929,2.637,2.637,0,0,0,21.775,17.5a.248.248,0,0,1-.173-.145.5.5,0,0,0-.459-.3H14A.5.5,0,0,0,13.5,17.548Zm8.143,1.878a.25.25,0,0,1,.131-.22.246.246,0,0,1,.255.011.9.9,0,0,1,.471.712.949.949,0,0,1-.562.767.2.2,0,0,1-.295-.172Z', 'M2.5,12H6.75a.25.25,0,0,1,.25.25v1a.249.249,0,0,1-.25.25H3.625a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2H9.25A.249.249,0,0,1,9,13.25v-1A.25.25,0,0,1,9.25,12H14a2.5,2.5,0,0,0,2.5-2.448c0-.017,0-.034,0-.052v-7A2.5,2.5,0,0,0,14,0H2.5A2.5,2.5,0,0,0,0,2.5v7c0,.018,0,.035,0,.052A2.5,2.5,0,0,0,2.5,12ZM2,2.5A.5.5,0,0,1,2.5,2H14a.5.5,0,0,1,.5.5V8a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,8Z']],
  TargetPath: ['target-path', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.5,23.02a.98.98,0,0,0-.98-.979H7.562a.98.98,0,1,0,0,1.959H9.521A.98.98,0,0,0,10.5,23.02Z', 'M4.294,21.4a4.434,4.434,0,0,1-1.625-1.736.98.98,0,1,0-1.738.906,6.4,6.4,0,0,0,2.343,2.5.968.968,0,0,0,.509.143A.979.979,0,0,0,4.294,21.4Z', 'M2.115,13.1A6.361,6.361,0,0,0,.408,16.072a.979.979,0,0,0,.711,1.189.945.945,0,0,0,.24.03.98.98,0,0,0,.949-.74A4.4,4.4,0,0,1,3.49,14.492a.98.98,0,1,0-1.375-1.4Z', 'M17.358,13.224a.98.98,0,0,0,0-1.959h-1.47a.98.98,0,0,0,0,1.959Z', 'M22.5,8.74a.979.979,0,0,0-1.342.347,4.383,4.383,0,0,1-1.171,1.307.98.98,0,1,0,1.173,1.57,6.387,6.387,0,0,0,1.688-1.883A.981.981,0,0,0,22.5,8.74Z', 'M23.622,5.807a1.075,1.075,0,0,0-.018-.193,6.362,6.362,0,0,0-1.554-3.06.98.98,0,1,0-1.444,1.324,4.393,4.393,0,0,1,1.075,2.116.981.981,0,0,0,.96.79.9.9,0,0,0,.191-.019A.979.979,0,0,0,23.622,5.807Z', 'M18.823,1.578A.978.978,0,0,0,17.935.516C17.744.5,17.553.49,17.358.49h-.98a.98.98,0,0,0,0,1.959h.98c.136,0,.27.007.4.018.03,0,.06,0,.088,0A.979.979,0,0,0,18.823,1.578Z', 'M8.579,9a.487.487,0,0,0,.452.3h1.225a.245.245,0,0,1,.245.245v9.8a1.469,1.469,0,0,0,2.938,0v-9.8a.245.245,0,0,1,.245-.245h1.225a.49.49,0,0,0,.346-.836L12.316,5.531a.489.489,0,0,0-.692,0L8.685,8.47A.49.49,0,0,0,8.579,9Z', 'M10.011 1.959 A1.959 1.959 0 1 0 13.929 1.959 A1.959 1.959 0 1 0 10.011 1.959 Z', 'M6.582,11.265a.98.98,0,0,0,0,1.959h1.47a.98.98,0,0,0,0-1.959Z']],
  TargetCenter: ['target-center', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.9,2.7a.5.5,0,0,0-.4-.2H21.75a.25.25,0,0,1-.25-.25V.5a.5.5,0,0,0-.648-.477A14.867,14.867,0,0,0,19,.769V3.835a.251.251,0,0,1-.073.178l-.5.5A.25.25,0,0,1,18,4.335V1.3a5.388,5.388,0,0,0-2.7,2.95,2.983,2.983,0,0,0,.586,2.511.252.252,0,0,1-.027.322l-.89.89a.247.247,0,0,1-.333.017A8.993,8.993,0,0,0,1.92,20.549a.249.249,0,0,1,0,.309L.716,22.38a1,1,0,0,0,.164,1.4,1.01,1.01,0,0,0,1.4-.164l1.052-1.33a.25.25,0,0,1,.344-.046,8.961,8.961,0,0,0,10.857-.153.25.25,0,0,1,.34.03l1.376,1.544a1.015,1.015,0,0,0,1.412.081,1,1,0,0,0,.082-1.411l-1.5-1.684a.252.252,0,0,1-.015-.316,8.947,8.947,0,0,0,.449-10.015.255.255,0,0,0-.4-.043L15,11.558a.242.242,0,0,0-.041.288,6.764,6.764,0,1,1-1.984-2.292.256.256,0,0,1,.1.183.251.251,0,0,1-.072.2l-.727.727a.252.252,0,0,1-.319.029,5.161,5.161,0,0,0-4.152-.8,5.253,5.253,0,1,0,6.1,6.947,5.1,5.1,0,0,0-.013-3.681.252.252,0,0,0-.411-.081l-1.213,1.213a.244.244,0,0,0-.067.213,2.975,2.975,0,0,1-.192,1.649A3.331,3.331,0,0,1,9.4,18.226a3.25,3.25,0,0,1-1.093-6.4,3.174,3.174,0,0,1,2.094.249.255.255,0,0,1,.137.184.252.252,0,0,1-.07.218l-.88.881A1.718,1.718,0,0,0,9,13.25,1.75,1.75,0,1,0,10.75,15a1.731,1.731,0,0,0-.107-.582l6.274-6.274a.25.25,0,0,1,.321-.028,3.2,3.2,0,0,0,1.863.667,2.683,2.683,0,0,0,.65-.08c2.68-.662,4.165-5.355,4.227-5.554A.5.5,0,0,0,23.9,2.7Z']],
  MazeStrategy: ['maze-strategy', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.5,2H2A2,2,0,0,0,0,4V22a2,2,0,0,0,2,2H9a1,1,0,0,0,0-2H5.75a.249.249,0,0,1-.25-.25V19.5a1,1,0,0,0-2,0v2.25a.249.249,0,0,1-.25.25h-1A.249.249,0,0,1,2,21.75v-9.5A.25.25,0,0,1,2.25,12h2.5a.25.25,0,0,1,.25.25V16a1,1,0,0,0,2,0V11a1,1,0,0,0-1-1H2.25A.249.249,0,0,1,2,9.75V4.25A.25.25,0,0,1,2.25,4h3a.25.25,0,0,1,.25.25v1.5A.249.249,0,0,1,5.25,6H4.5a1,1,0,0,0,0,2h2a1,1,0,0,0,1-1V4.25A.25.25,0,0,1,7.75,4H8.5a1,1,0,0,0,0-2Z', 'M24,4a2,2,0,0,0-2-2H19a1,1,0,0,0,0,2h2.75a.25.25,0,0,1,.25.25v1.5a.249.249,0,0,1-.25.25H18a1,1,0,0,0,0,2h3.75a.25.25,0,0,1,.25.25v2a.249.249,0,0,1-.25.25H13a1,1,0,0,0,0,2h1.75a.25.25,0,0,1,.25.25v2a.249.249,0,0,1-.25.25H13.5a1,1,0,0,0,0,2H16a1,1,0,0,0,1-1V12.75a.25.25,0,0,1,.25-.25h4.5a.25.25,0,0,1,.25.25v9a.249.249,0,0,1-.25.25h-1a.249.249,0,0,1-.25-.25V15a1,1,0,0,0-2,0v6.75a.249.249,0,0,1-.25.25H16a1,1,0,0,0,0,2h6a2,2,0,0,0,2-2Z', 'M12.25,7H9.5a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h1.75a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V19a1,1,0,0,0-1-1H10.75a.249.249,0,0,1-.25-.25V9.25A.25.25,0,0,1,10.75,9H13.5a1,1,0,0,0,1-1V4.235a.251.251,0,0,1,.25-.25h.75a.75.75,0,0,0,.586-1.218l-2-2.5a.777.777,0,0,0-1.172,0l-2,2.5A.75.75,0,0,0,11.5,3.985h.75a.251.251,0,0,1,.25.25V6.75A.249.249,0,0,1,12.25,7Z']]
};
exports["default"] = _default;